export default __webpack_public_path__ + "static/INSTAR_Cloud_Alexa_Skill_10-EN-f4c41ee6df767460fb1268aeaddb0df6.webp";